import React, { PureComponent } from "react";
import _ from "lodash";
import Resizable from "react-resizable-box";

import { ItemTypes, starterComponent } from "../constants/elements";
import Draggable from "./enhancers/draggable";
import Selectable from "./enhancers/selectable";
import Positionable from "./enhancers/positionable";
import DropTargetable from "./enhancers/dropTargetable";
import Animable from "./enhancers/animable";
import Collectionable from "./enhancers/collectionable";
import classNames from "classnames";
import { linkProps } from "../spreadsheet/linker";

import "./canvas.css";

class Canvas extends PureComponent {
  addBlockInside = (parent, type, item, top, left) =>
    this.props.onAddBlockInside(type, top, left, item, parent);

  //used to render in Preview mode or in OBS:
  renderBlockPreview(blockProps, collectionData) {
    return (
      <Positionable
        key={blockProps.cloneKey || blockProps.id}
        top={blockProps.top}
        left={blockProps.left}
        zIndex={blockProps.zIndex}
        locked={blockProps.locked}>
        {this.renderElem(blockProps, collectionData)}
      </Positionable>
    );
  }

  resolvePourcent = (blockProps, parent) => {
    const { width, height } = blockProps;
    const isPourcent = p => typeof p === "string" && p.indexOf("%") > -1;
    const par = parent;
    return {
      width: isPourcent(width) ? Number(width.split("%")[0]) * par.width / 100 : width,
      height: isPourcent(height) ? Number(height.split("%")[0]) * par.height / 100 : height
    };
  };

  renderElem(blockProps, collectionData) {
    const Elem = starterComponent(blockProps.type);
    const collData = blockProps.collectionData
      ? _.chain(blockProps.collectionData)
          .drop(blockProps.skip)
          .take(blockProps.limit)
          .value()
      : collectionData && collectionData[blockProps.collection];

    const renderer = (data, key) => (
      <Elem key={key} dataKey={key} {...linkProps(blockProps, data)}>
        {blockProps.children &&
          blockProps.children.map(c => {
            return this.props.blocks[c].hidden ? (
              <span />
            ) : (
              this.renderBlockPreview(this.props.blocks[c], data || collectionData)
            );
          })}
      </Elem>
    );

    return collData ? (
      <Collectionable key={blockProps.id} block={blockProps}>
        {collData.map((data, i) => {
          const key = data[blockProps.collection + ".__id"];
          return renderer(data, key);
        })}
      </Collectionable>
    ) : blockProps.collection && blockProps.collection !== "none" ? (
      <span />
    ) : (
      renderer(collectionData, blockProps.id)
    );
  }

  renderBlock(blockProps) {
    return this.renderBlockPreview(blockProps);
  }

  checkSnap = (id, pos) => {
    const b = this.props.blocks[id];
    const bros = this.props.blocks[b.parent].children.map(c => c !== id && this.props.blocks[c]);
    let p = undefined;
    for (var i = 0; i < bros.length; i++) {
      const c = bros[i];
      if (Math.abs(c.left - pos.left) < 10) {
        p = { left: c.left };
        break;
      }
      if (Math.abs(c.left + c.width - (pos.left + b.width)) < 10) {
        p = { left: c.left + c.width - b.width };
        break;
      }
      if (Math.abs(c.top - pos.top) < 10) {
        p = { top: c.top };
        break;
      }
    }
    return p;
  };

  onDrag = (id, ps) => {
    //const snap = this.checkSnap(id, ps);
    this.props.updateProperties(id, ps);
  };

  renderEditingLayer(blockProps, collectionData) {
    const resizeConstraints = this.props.constrained
      ? {
          maxWidth:
            this.props.blocks[blockProps.parent] &&
            this.props.blocks[blockProps.parent].width - blockProps.left,
          maxHeight:
            this.props.blocks[blockProps.parent] &&
            this.props.blocks[blockProps.parent].height - blockProps.top,
          minWidth:
            blockProps.width -
            (blockProps.width -
              (_.max(
                blockProps.children.map(c => this.props.blocks[c].left + this.props.blocks[c].width)
              ) || 0)),
          minHeight:
            blockProps.height -
            (blockProps.height -
              (_.max(
                blockProps.children.map(c => this.props.blocks[c].top + this.props.blocks[c].height)
              ) || 0))
        }
      : {};
    const enhancers = [
      [
        "span",
        {
          key: "d" + (blockProps.cloneKey || blockProps.id),
          id: "d" + (blockProps.cloneKey || blockProps.id),
          style: {
            position: "relative",
            pointerEvents: blockProps.locked || blockProps.hidden ? "none" : "auto"
          },
          type: blockProps.type,
          onMouseDown: e => {
            e.stopPropagation();
            this.props.onSelect(blockProps.id);
          }
        }
      ],
      [
        Draggable,
        {
          ...this.tlwh(blockProps),
          onDrag: blockProps.fixed ? () => {} : this.onDrag,
          id: blockProps.id
        },
        blockProps.id !== "canvas"
      ],
      [
        Animable,
        {
          enterAnimation: blockProps.enterAnimation,
          leaveAnimation: blockProps.leaveAnimation,
          delay: blockProps.delay
        },
        false //blockProps.enterAnimation !== undefined && blockProps.enterAnimation !== "none"
      ],
      [
        Resizable,
        Object.assign(resizeConstraints, {
          width: blockProps.width,
          height: blockProps.height,
          //so it doesnt drag as well
          onResizeStart: (e, dir, ref) => {
            e.stopPropagation();
            this.props.onSelect(blockProps.id);
          },
          lockAspectRatio: blockProps.lockAspectRatio,
          onClick: e => {
            e.stopPropagation();
            this.props.onSelect(blockProps.id);
          },
          onResize: (e, dir, ref, delta) => {
            const size = { width: ref.clientWidth, height: ref.clientHeight };
            this.props.updateProperties(blockProps.id, {
              width: size.width,
              height: size.height,
              left:
                dir.toLowerCase().indexOf("left") > -1
                  ? blockProps.left - (size.width - blockProps.width)
                  : blockProps.left,
              top:
                dir.toLowerCase().indexOf("top") > -1
                  ? blockProps.top - (size.height - blockProps.height)
                  : blockProps.top
            });
          }
        }),
        blockProps.id !== "canvas" && !blockProps.fixed && !blockProps.hidden
      ],
      [
        "div",
        {
          style: Object.assign({}, this.position(this.props.blocks.canvas), {
            zIndex: 10,
            top: 0,
            left: 0
          }),
          key: "d" + blockProps.id,
          className: "position-canvas"
        },
        blockProps.id === "canvas"
      ],
      [
        DropTargetable,
        {
          onDropBlockInside: this.addBlockInside,
          id: blockProps.id,
          type: blockProps.type,
          canvas: blockProps.id === "canvas"
        },
        [ItemTypes.ELEMENT_EMPTYCONTAINER, ItemTypes.ELEMENT_SLIDER].indexOf(blockProps.type) >
          -1 && !blockProps.hidden
      ]
    ];

    const Elem = starterComponent(blockProps.type);
    const collData = blockProps.collectionData
      ? _.chain(blockProps.collectionData)
          .drop(blockProps.skip)
          .take(blockProps.limit)
          .value()
      : collectionData && collectionData[blockProps.collection];

    const withSelect = (
      <div>
        <Selectable
          key={"s" + blockProps.id}
          selected={this.props.selectedBlock === blockProps.id && blockProps.id !== "canvas"}
          isCanvas={blockProps.id === "canvas"}
          showOutline={this.props.showOutline}
        />
        <div>
          {collData ? (
            <Collectionable key={blockProps.id} block={blockProps}>
              {collData.map((data, i) => {
                const key = data[blockProps.collection + ".__id"];
                return (
                  <Elem key={key} dataKey={key} {...linkProps(blockProps, data)}>
                    {blockProps.children.map(c => {
                      return this.renderEditingLayer(this.props.blocks[c], data);
                    })}
                  </Elem>
                );
              })}
            </Collectionable>
          ) : (
            <Elem {...linkProps(blockProps, collectionData)}>
              {blockProps.children.map(c => {
                return this.renderEditingLayer(this.props.blocks[c], collectionData);
              })}
            </Elem>
          )}
        </div>
      </div>
    );

    return enhancers.reverse().reduce((acc, [el, props, condition]) => {
      return condition !== false
        ? React.createElement(el, Object.assign({}, props, { children: acc }))
        : acc;
    }, !blockProps.hidden && withSelect);
  }

  tlwh = block => _.pick(block, ["top", "left", "width", "height"]);
  position = block => Object.assign({ position: "absolute" }, this.tlwh(block));

  render() {
    const { editing } = this.props;
    return (
      <div
        id="rootcanvas"
        className={classNames("canvas", { editing: editing })}
        ref={c => {
          this.canvas = c;
        }}
        style={{ width: this.props.blocks.canvas.width, height: this.props.blocks.canvas.height }}>
        {this.props.editing
          ? this.renderEditingLayer(this.props.blocks.canvas)
          : this.renderBlock(this.props.blocks.canvas)}
      </div>
    );
  }
}

export default Canvas;



// WEBPACK FOOTER //
// ./src/canvas/index.js